/**
 * Created by andrey on 14.01.2021.
 */

const MergeTutorial = function () {
    cleverapps.EventEmitter.call(this);

    this.fresh = [];

    cleverapps.eventBus.on("mapEvent", this.onMapEvent.bind(this), this);
    cleverapps.eventBus.on("window_shown", this.onWindowShown.bind(this), this);
    cleverapps.eventBus.on("closeWindows", this.onCloseWindows.bind(this), this);
};

MergeTutorial.prototype = Object.create(cleverapps.EventEmitter.prototype);
MergeTutorial.prototype.constructor = MergeTutorial;

MergeTutorial.prototype.isActive = function () {
    return this.runningTutorial;
};

MergeTutorial.prototype.checkConditions = function (options) {
    options = options || {};

    if (!this.isActive() || !this.step) {
        return false;
    }

    if (options.unit && !cleverapps.intersect(this.step.targets, options.unit, Unit.GetKey).length) {
        return false;
    }

    if (options.fog && !cleverapps.intersect(this.step.targets, options.fog).length) {
        return false;
    }

    if (options.advice && !cleverapps.intersect(this.step.type, options.advice).length) {
        return false;
    }

    if (options.move) {
        const move = Map2d.currentMap.advice.getCurrentMove();
        return move && move.cells[0].x === options.move.x && move.cells[0].y === options.move.y;
    }

    if (options.preferCell && !cc.pointEqualToPoint(options.preferCell, this.step.preferCell)) {
        return false;
    }

    if (options.monster && this.step.monster !== options.monster) {
        return false;
    }

    return true;
};

MergeTutorial.prototype.showTutorial = function (tutorial, callback) {
    if (cleverapps.gameModes.skipTutorials) {
        callback();
        return;
    }

    if (tutorial.filter && !tutorial.filter()) {
        callback();
        return;
    }

    let steps = tutorial.steps;

    if (tutorial.replayed) {
        steps = this.filterReplayedSteps(steps);
    }

    const actions = steps.map((step, index) => function (f, stop) {
        if (!this.finished) {
            this.showTutorialStep(step, index, f);
        } else {
            stop();
        }
    }.bind(this));

    if (cleverapps.focusManager.focus === "mergeTutorial") {
        cleverapps.throwAsync(`Trying to show a tutorial when another tutorial is already running, current: ${this.runningTutorialId}, step: ${this.runningIndex}, new: ${tutorial.id}`);

        callback();

        return;
    }

    cleverapps.focusManager.display({
        stack: true,
        focus: "mergeTutorial",
        actions: [
            function (f) {
                this.finished = false;
                this.runningTutorial = steps;
                this.runningTutorialId = tutorial.id;
                Map2d.currentMap.advice.stopHint();
                InfoView.CloseInfo(undefined, true);
                f();
            }.bind(this),

            function (f) {
                cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);

                const player = new ActionPlayer(actions);
                player.onComplete(f);
                player.play();
            },

            function (f) {
                cleverapps.focusManager.hideControlsWhileFocused("map2d");

                delete this.runningTutorial;
                delete this.runningTutorialId;
                delete this.finished;

                this.trigger("finishTutorial");

                f();
                callback();
            }.bind(this)
        ]
    });
};

MergeTutorial.prototype.filterReplayedSteps = function (steps) {
    const advice = Map2d.currentMap.advice;

    for (let i = steps.length - 1; i >= 0; --i) {
        const step = steps[i];
        advice.setLogic(step.type, step);
        if (advice.hasHints() && (!step.targets || advice.findMove())) {
            return steps.slice(i);
        }
    }
    return steps;
};

MergeTutorial.prototype.showTutorialStep = function (step, index, f) {
    const type = MergeTutorial.Types[step.type] || {};

    this.step = step = cleverapps.clone({ ...type, ...step }, true);
    if (step.targets) {
        step.targets = cleverapps.toArray(step.targets);
    }

    this.runningIndex = index;
    this.onceStepCallback = cleverapps.once(f);

    this.onceFinishTutorialStep = cleverapps.once(this.finishTutorialStep.bind(this));

    const visibleControls = (type.controls || ["map2d"]).concat(step.controls || []);
    const hiddenControls = cleverapps.focusManager.controls.filter((control) => visibleControls.indexOf(control) === -1);
    cleverapps.focusManager.hideControlsWhileFocused(hiddenControls);
    cleverapps.focusManager.showControlsWhileFocused(visibleControls);

    const advice = Map2d.currentMap.advice;
    advice.setLogic(step.type, step);

    const waitMove = step.wait || MergeTutorial.WAIT_MOVE;

    const callback = cleverapps.once(() => {
        this.clearFinishAllTimeout();

        const move = advice.findMove();
        if (advice.hasHints() && (!step.targets || move)) {
            this.trigger("showTutorialStep", step, move);
        } else if (step.type === Map2d.FORCE) {
            const force = cleverapps.clone(step.force, true);
            force.text = step.text;
            force.person = typeof step.person === "function" && step.targets ? step.person(step.targets[0]) : step.person;
            force.target = typeof force.target === "function" ? force.target() : force.target;

            cleverapps.forces.onceForceClosed = this.runOnceFinishTutorialStep.bind(this);
            cleverapps.forces.create(undefined, force);
        } else if (step.type === Map2d.CLOSE_WINDOWS) {
            cleverapps.focusManager.onceTutorialNoWindowsListener = () => this.runOnceFinishTutorialStep();
            this.trigger("showTutorialStep", step, {});
        } else {
            this.runOnceFinishTutorialStep();
        }
    });

    if (advice.hasHints() && (step.wait || (!step.targets || advice.findMove()))) {
        this.finishAllTimeout = setTimeout(this.finishAll.bind(this), cleverapps.parseInterval(waitMove));
        this.onShowHintCallback = callback;
        this.launchHint();
    } else {
        callback();
    }
};

MergeTutorial.prototype.launchHint = function () {
    Map2d.currentMap.advice.startHint({
        arrow: { delay: this.step.arrowDelay === undefined ? MergeTutorial.ARROW_DELAY : this.step.arrowDelay },
        highlight: this.step.highlight,
        finger: {
            delay: this.step.fingerDelay === undefined ? MergeTutorial.FINGER_DELAY : this.step.fingerDelay,
            repeatDelay: 2
        }
    });
};

MergeTutorial.prototype.onWindowShown = function () {
    const currentWindow = cleverapps.focusManager.currentWindow();
    if ([Map2d.BUY_FREE_UNIT].includes(this.getCurrentStepType()) && currentWindow && ShopWindow.getUnitsController(currentWindow)) {
        this.step.unitsShopWindowOpened = true;
    }

    this.trigger("showUpWindow");
};

MergeTutorial.prototype.onCloseWindows = function () {
    if ([Map2d.BUY_FREE_UNIT].includes(this.getCurrentStepType()) && this.step.unitsShopWindowOpened) {
        this.finishAll();
    }
    this.trigger("closeWindows");
};

MergeTutorial.prototype.onShowHint = function () {
    if (this.isActive() && this.onShowHintCallback) {
        this.onShowHintCallback();
    }
};

MergeTutorial.prototype.onMapEvent = function (type, options) {
    if (!this.isActive() || this.stepFinished || !this.step) {
        return;
    }

    const types = this.step.types || [this.step.type];
    if (types.indexOf(type) === -1) {
        return;
    }

    if (this.step.allMoves && Map2d.currentMap.advice.findMove()) {
        return;
    }

    if (this.step.affected && options.affected && !cleverapps.intersect(this.step.targets, options.affected, Unit.GetKey).length) {
        return;
    }

    this.wantNextStep();
};

MergeTutorial.prototype.wantNextStep = function () {
    this.stepFinished = true;

    if (!Map2dLocation.currentLocation.counter.isActive()) {
        this.runOnceFinishTutorialStep();
    } else {
        this.readyForNextStep = true;
    }
};

MergeTutorial.prototype.nextStep = function () {
    if (this.readyForNextStep) {
        this.runOnceFinishTutorialStep();
    }

    this.readyForNextStep = false;
};

MergeTutorial.prototype.triggerTutorial = function (tutorial) {
    if (tutorial && this.runningTutorial !== tutorial && this.fresh.indexOf(tutorial) === -1) {
        this.fresh.push(tutorial);
        Map2dLocation.currentLocation.counter.trigger();
    }
};

MergeTutorial.prototype.processFresh = function () {
    if (!this.fresh.length || cleverapps.focusManager.isFocused() || Map2d.currentMap.dragging) {
        return;
    }

    const tutorial = this.fresh.shift();

    cleverapps.focusManager.display({
        focus: "StartTutorial",
        action: function (f) {
            this.showTutorial(tutorial, f);
        }.bind(this)
    });
};

MergeTutorial.prototype.destructor = function () {
    this.trigger("finishTutorialStep");
    this.clearFinishAllTimeout();
    runCleaners(this);
};

MergeTutorial.prototype.clearFinishAllTimeout = function () {
    if (this.finishAllTimeout) {
        clearTimeout(this.finishAllTimeout);
        delete this.finishAllTimeout;
    }
};

MergeTutorial.prototype.runOnceFinishTutorialStep = function () {
    if (this.onceFinishTutorialStep) {
        const callback = this.onceFinishTutorialStep;
        delete this.onceFinishTutorialStep;
        callback();
    }
};

MergeTutorial.prototype.finishAll = function () {
    this.finished = true;
    this.runOnceFinishTutorialStep();
};

MergeTutorial.prototype.isFirstStep = function () {
    return this.runningIndex === 0;
};

MergeTutorial.prototype.isLastStep = function () {
    return this.runningIndex === this.runningTutorial.length - 1;
};

MergeTutorial.prototype.getCurrentStepType = function () {
    return this.step && this.step.type;
};

MergeTutorial.prototype.finishTutorialStep = function () {
    Map2d.currentMap.advice.stopHint();

    this.logTutorialStep();

    if (this.step.waitAfter) {
        Map2dLocation.currentLocation.counter.setTimeout(this.runNextStep.bind(this), this.step.waitAfter);
        return;
    }

    if (this.finished || this.isLastStep()) {
        this.runNextStep();
    } else {
        Map2dLocation.currentLocation.counter.setTimeout(this.runNextStep.bind(this), 300);
    }
};

MergeTutorial.prototype.logTutorialStep = function () {
    if (!MergeTutorial.LOG_TUTORIALS.includes(this.runningTutorialId)) {
        return;
    }

    let step = this.runningIndex;
    for (let i = 0; i < MergeTutorial.LOG_TUTORIALS.length; i++) {
        const id = MergeTutorial.LOG_TUTORIALS[i];

        if (id === this.runningTutorialId) {
            break;
        }

        step += MergeTutorials[id].steps.length;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.TUTORIAL_STEP + step);
};

MergeTutorial.prototype.runNextStep = function () {
    delete this.step;
    delete this.stepFinished;
    delete this.runningIndex;
    delete this.onShowHintCallback;

    this.trigger("finishTutorialStep");

    this.clearFinishAllTimeout();

    if (this.onceStepCallback) {
        const onceStepCallback = this.onceStepCallback;
        delete this.onceStepCallback;
        onceStepCallback();
    }
};

MergeTutorial.prototype.getId = function () {
    return this.runningTutorialId;
};

MergeTutorial.WAIT_MOVE = "10 seconds";

MergeTutorial.LOG_TUTORIALS = [];

MergeTutorial.ARROW_DELAY = 7;
MergeTutorial.FINGER_DELAY = 3.5;
